import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

class PageOverlay extends React.Component {
  static propTypes = {
    isOffCanvasActive: PropTypes.bool.isRequired,
    toggleOffCanvas: PropTypes.func.isRequired
  }

  toggleOffCanvasNav (direction, event) {
    event.preventDefault()
    this.props.toggleOffCanvas(direction)
  }

  render () {
    let PageOverlayClass = classNames('page__overlay', {
      'page__overlay--is-active': this.props.isOffCanvasActive
    })
    return (
      <div className={PageOverlayClass} onClick={this.toggleOffCanvasNav.bind(this, 'close')} />
    )
  }
}

export default PageOverlay



// WEBPACK FOOTER //
// ./client/components/pageOverlay.js